import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import Store from '../../Store';
import { ButtonProps } from '@material/react-button';
import { OnCenterDocument } from '../_actions/ToolsActions';
import CenterButton from '../_components/CenterButton';

const mapDispatchToProps = (dispatch:Dispatch, props:ButtonProps<HTMLButtonElement>) => ({
	onClick: () => dispatch(OnCenterDocument())
});

export default connect(
	null,
	mapDispatchToProps
)(CenterButton);